import type { RouteRecordRaw } from 'vue-router';

export const refundRoutes: Array<RouteRecordRaw> = [
  {
    path: '/refund',
    name: 'refund',
    redirect: '/refund/list',
    component: () => import('pages/trade/admin/refund/OrderRefund.vue'),
    meta: {
      title: 'Refund',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'refundList',
        component: () => import('pages/trade/admin/refund/RefundList.vue'),
        meta: {
          title: 'Refund List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'refundDetail',
        component: () => import('pages/trade/admin/refund/RefundDetail.vue'),
        meta: {
          title: 'Refund Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'refundNew',
        component: () => import('pages/trade/admin/refund/RefundNew.vue'),
        meta: {
          title: 'New Refund',
          requiresAuth: true,
        },
      },
    ],
  },
];
